import { Injectable } from '@angular/core';

@Injectable()
export class Base64Service {

  constructor() { }

  private base: string;

  convert(file: File, callback): void {
    this.base = '';
    const myReader = new FileReader();
    myReader.readAsDataURL(file);

    myReader.onloadend = () => {
      callback(myReader.result.split(',')[1]);
    };
  }

  convertToBlobPDF(dataURI, callback): void {
    // convert base64 to raw binary data held in a string
    // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
    const byteString = atob(dataURI);

    // separate out the mime component
    const mimeString = 'application/pdf';

    // write the bytes of the string to an ArrayBuffer
    const ab = new ArrayBuffer(byteString.length);
    const ia = new Uint8Array(ab);
    for (let i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }

    // write the ArrayBuffer to a blob, and you're done
    const bb = new Blob([ab], {
      type: mimeString
    });
    // bb.append(ab);
    callback(bb);
  }

}



// WEBPACK FOOTER //
// ./src/app/services/base64.service.ts